export default __webpack_public_path__ + "static/media/drdong-md-2x.6a159bb1.jpg";